export default "__VITE_ASSET__b6036930__"